import React, { useEffect, useState } from 'react';
import { Footer } from 'structure/Layouts/SFILayouts/BaseLayout/components/Footer';
import { Content } from 'structure/Layouts/SFILayouts/BaseLayout/components/Content';
import { HeaderCommon } from 'structure/Layouts/SFILayouts/BaseLayout/components/HeaderCommon';
import { SideBar } from 'structure/Layouts/LayoutWithSideBar/desktop/SideBar';
import { Banner } from './components/Banner';
import { appConfig } from 'utils/app.config';
import { usePathname } from 'next/navigation';
import { cx } from 'class-variance-authority';

interface BaseLayoutProps {
  children: React.ReactNode;
  header?: React.ReactNode;
  showFooter?: boolean;
  sidebar?: boolean;
  classNames?: {
    content?: string;
  };
}

export const BaseLayout = (props: BaseLayoutProps) => {
  const { header, children, classNames, showFooter = true } = props;
  const { content } = classNames || {};
  const [isBannerClosed, setIsBannerClosed] = useState(false);
  const path = usePathname();
  const sidebar = !path?.includes('/testnet') && path !== '/';

  useEffect(() => {
    setIsBannerClosed(Boolean(sessionStorage?.getItem('isBannerVisible')));
  }, []);

  const handleCloseBanner = () => {
    setIsBannerClosed(true);
  };

  return (
    <>
      <Banner onClose={handleCloseBanner} />
      <div
        className={`flex h-dvh flex-col ${appConfig.featureFlags.ENABLE_BANNER && !isBannerClosed && 'lg:h-[calc(100vh-2rem)]'} items-center bg-box-primary`}
      >
        {header ? header : <HeaderCommon isBannerClosed={isBannerClosed} />}
        <div className={`relative flex w-full justify-center`}>
          {sidebar && <SideBar isBannerClosed={isBannerClosed} />}
          <div className={`mx-auto flex w-full flex-col items-center`}>
            <Content
              className={cx(
                content,
                sidebar ? 'lg:pl-32 lg:pr-3 xl:pl-32 xl:pr-3' : ''
              )}
            >
              {children}
            </Content>
            {showFooter ? (
              <Footer
                className={sidebar ? 'lg:pl-32 lg:pr-3 xl:pl-32 xl:pr-3' : ''}
              />
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};
